import { createTheme } from '@mui/material/styles';

const fontSans = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const theme = createTheme({
  palette: {
    primary: {
      light: '#4dcad5',
      main: '#1c9aaa',
      dark: '#167a88',
      contrastText: '#ffffff',
    },
    error: { light: '#fee2e2', main: '#ef4444', dark: '#dc2626' },
    success: { light: '#dcfce7', main: '#22c55e', dark: '#16a34a' },
    warning: { light: '#fef3c7', main: '#f59e0b', dark: '#d97706' },
    info: { light: '#dbeafe', main: '#3b82f6', dark: '#2563eb' },
  },
  typography: {
    fontFamily: fontSans,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#f8fafc',
          fontFamily: fontSans,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: fontSans,
          textTransform: 'none',
          fontWeight: 600,
          letterSpacing: '-0.01em',
          borderRadius: '8px',
        },
        contained: {
          background: 'linear-gradient(135deg, #1c9aaa 0%, #167a88 100%)',
          boxShadow: '0 4px 14px 0 rgba(28, 154, 170, 0.25)',
          color: '#ffffff',
          '&:hover': {
            background: 'linear-gradient(135deg, #167a88 0%, #115b66 100%)',
            boxShadow: '0 6px 20px rgba(28, 154, 170, 0.35)',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { fullWidth: true },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: fontSans,
          backgroundColor: '#ffffff',
          '&.Mui-disabled': { backgroundColor: '#f8fafc' },
          '&::before, &::after': { display: 'none' },
        },
        input: {
          fontSize: '14px',
          fontWeight: 500,
          color: '#1e293b',
          '&::placeholder': { color: '#94a3b8', opacity: 1, fontWeight: 400 },
          '&.Mui-disabled': { WebkitTextFillColor: '#64748b' },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1c9aaa',
            borderWidth: '1px',
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: '#334155',
          lineHeight: 1.4,
          margin: '0 0 0 -3px',
          gap: '6px',
        },
        label: {
          fontSize: '14px',
          fontWeight: 500,
          color: '#334155',
          display: 'inline-flex',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0,
          color: '#cbd5e1',
          transition: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
          '&.Mui-checked': { color: '#1c9aaa' },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          background: 'transparent',
          boxShadow: 'none',
          margin: '0 !important',
          '&::before': { display: 'none' },
          '&.Mui-expanded': { margin: '0 !important' },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          minHeight: '46px',
          '&.Mui-expanded': { minHeight: '46px' },
        },
        content: {
          margin: '0 !important',
        },
      },
    },
  },
});
